import { Link } from '@remix-run/react'
import { getUserImgSrc } from '~/utils/misc.ts'

export default function UserDetails({ user }) {
	const { name, username, imageId } = user
	const userDisplayName = name || username

	return (
		<Link to={`/${user.username}`}>
			<div className="group flex flex-row items-center gap-4">
				<img
					src={getUserImgSrc(imageId)}
					alt={userDisplayName}
					className="h-12 w-12 rounded-full object-cover transition-opacity group-hover:opacity-80"
				/>
				<div className="max-w-md">
					<h2 className="text-xl group-hover:text-foreground-medium">
						{userDisplayName}
					</h2>
				</div>
			</div>
		</Link>
	)
}
